import React from "react";
import Layout from "../../Layout";
import Teams from "../../containers/Teams";

export default function TeamsPage() {
  return (
    <Layout>
      <Teams />
    </Layout>
  );
}
